module.exports = __webpack_public_path__ + "video-faf4753cb5a9.webm";